import { skillScheduleActions } from '../skillSchedules/skillSchedule-slice';
import { getData, updateItem, createItem, deleteItem, executeItem } from '../common-actions';
import { fetchSkillSchedules, 
    createSkillSchedule as apiCreateSkillSchedule, 
    updateSkillSchedule as apiUpdateSkillSchedule, 
    deleteSkillSchedule as apiDeleteSkillSchedule,
    changeSkillLevels as apiChangeSkillLevels,
    reverseSkillLevels as apiReverseSkillLevels} from '../../lib/api';

export const getSkillSchedules = (signal, token) => {

    return getData({
      token: token,
      actions: skillScheduleActions,
      fetchFn: (token) => fetchSkillSchedules(signal, token),
      dataKey: "skillSchedules",
      name: "get skillSchedules",
      setFunctionName: "setSkillSchedules",
      signal: signal
    });
};

export const createSkillSchedule = (token, skillSchedule, navigate) => {

    return createItem({
      token: token,
      actions: skillScheduleActions,
      createFn: apiCreateSkillSchedule,
      dataKey: "skillSchedule",
      name: "create skillSchedule",
      actionFunctionName: "createSkillSchedule",
      item: skillSchedule,
      navigate: navigate,
      showConfirmation: true,
      confirmationFn: (item) => `Schedule "${item && item.name ? item.name : "unknown"}" has been created successfully`
    });
};

export const updateSkillSchedule = (token, skillSchedule) => {

    return updateItem({
      token: token,
      actions: skillScheduleActions,
      updateFn: apiUpdateSkillSchedule,
      dataKey: "skillSchedule",
      name: "update skillSchedule",
      actionFunctionName: "setSkillSchedule",
      item: skillSchedule,
      doNotInvalidate: true,
      showConfirmation: true,
      confirmationFn: (item) => `Schedule "${item && item.name ? item.name : "unknown"}" has been updated successfully`
    });
};

export const deleteSkillSchedule = (token, skillSchedule) => {

    return deleteItem({
      token: token,
      actions: skillScheduleActions,
      deleteFn: apiDeleteSkillSchedule,
      dataKey: "skillSchedule",
      name: "delete skillSchedule",
      actionFunctionName: "deleteSkillSchedule",
      item: skillSchedule,
      showConfirmation: true,
      confirmationFn: (item) => `Schedule "${item && item.name ? item.name : "unknown"}" has been deleted successfully`
    });
};

export const changeSkillLevels = (token, scheduleName) => {
  return executeItem({
    token: token,
    actions: skillScheduleActions,
    name: scheduleName,
    executeFn: apiChangeSkillLevels
  })
}

export const reverseSkillLevels = (token, scheduleName) => {
    return executeItem({
    token: token,
    actions: skillScheduleActions,
    name: scheduleName,
    executeFn: apiReverseSkillLevels
  })
}
